import PropTypes from 'prop-types';
import styles from './List.module.scss';
import ListItem from './ListItem';
import React from 'react';

export default function List(props) {
	const renderItem = (item, index) => {
		return ({ item }) => props.itemTemplate();
	};

	return (
		<div className={styles.container}>
			{(props.items || []).map((item, index) => {
				return (
					<React.Fragment key={index}>
						{props.itemTemplate({ item })}
					</React.Fragment>
				);
			})}
		</div>
	);
}

List.propTypes = {
	items: PropTypes.array,
	itemTemplate: PropTypes.any,
};
